import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavigationMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "navigation-menu" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 18.003,
			x2: 21.75,
			y2: 18.003
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 12.003,
			x2: 21.75,
			y2: 12.003
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 2.25,
			y1: 6.003,
			x2: 21.75,
			y2: 6.003
		})
	]
});
export default SvgNavigationMenu;
